import React from "react";
import { applyClassName, styled } from "@glitz/react";
import { useCart } from "../context/CartContext";
import { GrFormTrash } from "react-icons/gr";
import { spacing, green, fontSize, fontWeight, grey } from "../theme";
import SlimQuantitySelector from "./basic/SlimQuantitySelector";

const CartItems: React.FC = () => {
  const { cart, removeFromCart, updateItemQuantity } = useCart();

  return (
    <CartItemWrapper>
      {cart && cart.length != 0 ? (
        cart.map((item, index) => {
          const showDivider = cart.length !== 1 && index + 1 !== cart.length;
          return (
            <div key={index}>
              <Item>
                <Thumbnail src={item.img} loading="lazy" decoding="async" />
                <ItemInfo>
                  <ItemName>{item.name}</ItemName>
                  <Price>{item.price} kr</Price>
                  <SlimQuantitySelector
                    initialQuantity={item.quantity}
                    onAdd={() => updateItemQuantity(item.id, item.quantity + 1)}
                    onSubtract={() =>
                      updateItemQuantity(item.id, item.quantity - 1)
                    }
                  />
                </ItemInfo>
                <Icon onClick={() => removeFromCart(item.id)} />
              </Item>
              {showDivider && (
                <DividerWrapper>
                  <Divider />
                </DividerWrapper>
              )}
            </div>
          );
        })
      ) : (
        <>Din varukorg är tom</>
      )}
    </CartItemWrapper>
  );
};
const CartItemWrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: spacing.l,
  width: "100%",
});
const DividerWrapper = styled.div({
  display: "flex",
  width: "100%",
  justifyContent: "center",
  marginTop: spacing.m,
});

const Divider = styled.div({
  width: "80%",
  borderBottom: { style: "solid", color: grey, width: "2px" },
});

const Item = styled.div({
  display: "flex",
  width: "100%",
  justifyContent: "space-between",
  alignItems: "center",
});

const ItemInfo = styled.div({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: spacing.xs,
});

const ItemName = styled.div({
  textAlign: "center",
  fontSize: fontSize.m,
});

const Price = styled.div({
  textAlign: "center",
  fontSize: fontSize.l,
  fontWeight: fontWeight.bold,
});

const Icon = styled(applyClassName(GrFormTrash), {
  fontSize: "35px",
  color: green,
  cursor: "pointer",
  marginRight: spacing.xs,
});

const Thumbnail = styled.img({
  width: "auto",
  height: "70px",
  cursor: "pointer",
});

export default CartItems;
